/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useState } from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Tooltip, Typography } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

/*
* The following component checks whether the text is overflowing and if so applies a tag suffix
* at the end of the text, which on hover, presents the full text in a tooltip
*/
const TableCellTypography = ({ children, ...rest }) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  return (
    <Typography.Paragraph
      {...rest}
      className="table-cell-typography mb-0"
      ellipsis={{
        suffix: isOverflowing ? (
          <Tooltip
            title={children}
            overlayInnerStyle={{ maxHeight: 132, overflow: 'auto' }}
            destroyTooltipOnHide
          >
            <span className="position-absolute bg-layout-gray border-radius-base bordered py-0 px-1">
              <EllipsisOutlined />
            </span>
          </Tooltip>
        ) : '',
        onEllipsis: (ellipsis) => setIsOverflowing(ellipsis)
      }}
    >
      {children}
    </Typography.Paragraph>
  );
};

TableCellTypography.propTypes = {
  children: PropTypes.any
};

export default TableCellTypography;
